import { render, staticRenderFns } from "./AdvancedTxPlannedV2Skeleton.vue?vue&type=template&id=077c9d43&scoped=true"
import script from "./AdvancedTxPlannedV2Skeleton.vue?vue&type=script&lang=js"
export * from "./AdvancedTxPlannedV2Skeleton.vue?vue&type=script&lang=js"
import style0 from "./AdvancedTxPlannedV2Skeleton.vue?vue&type=style&index=0&id=077c9d43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077c9d43",
  null
  
)

export default component.exports